import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  firstDayOfMonthDate,
  lastDayOfMonthDate,
} from '@epicuro-next/utilities';

import { ngbDateToUTC } from '../../utils';

@Component({
  selector: 'atx-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe],
  standalone: false,
})
export class MonthPickerComponent implements OnInit, OnChanges {
  public selectedMonth: number | null = null;
  public selectedYear: number;
  public minMonthDate: Date | null;
  public maxMonthDate: Date | null;

  public months = new Array(12);
  public get years() {
    const year = this.selectedYear ?? this.year ?? new Date().getFullYear();
    return [year - 1, year, year + 1];
  }

  @Output() public monthSelect = new EventEmitter<string>();

  @Output() public yearSelect = new EventEmitter<number>();

  @Input() public month: number;
  @Input() public year: number;

  @Input() public set minDate(date: Date | null) {
    if (date) {
      this.minMonthDate = firstDayOfMonthDate(date);
    }
  }
  @Input() public set maxDate(date: Date | null) {
    this.maxMonthDate = date ? lastDayOfMonthDate(date) : null;
  }

  constructor(private datePipe: DatePipe) {}

  public ngOnInit() {
    this.initMonths();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.month) {
      this.selectedMonth = changes.month.currentValue - 1;
    }
    if (changes.year) {
      this.selectedYear = changes.year.currentValue;
    }
  }

  public initMonths() {
    for (let index = 0; index < this.months.length; index++) {
      this.months[index] = this.datePipe.transform(
        `${this.year}-${index + 1}-1`,
        'MMM',
      );
    }
  }

  public selectMonth(month: number) {
    this.selectedMonth = month;
    this.monthSelect.emit(
      ngbDateToUTC({
        year: this.selectedYear,
        month: this.selectedMonth + 1,
        day: 1,
      }),
    );
  }

  public selectYear(year: number) {
    this.selectedYear = year;
    this.selectedMonth = null;
    this.yearSelect.emit(year);
  }

  public isMonthDisabled(month: number) {
    const dateForMonth = new Date(this.selectedYear, month);
    return (
      (this.minMonthDate && dateForMonth < this.minMonthDate) ||
      (this.maxMonthDate && dateForMonth > this.maxMonthDate)
    );
  }

  public isYearDisabled(year: number) {
    return (
      (this.minMonthDate && year < this.minMonthDate.getFullYear()) ||
      (this.maxMonthDate && year > this.maxMonthDate.getFullYear())
    );
  }
}
